<template>
  <div class="ads-sku-mgmt">
    <div class="header-box">
      <span class="header-label">日期</span>
      <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small"
        value-format="yyyy-MM-dd" style="width: 230px;">
      </el-date-picker>
      <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
    </div>
    <el-table :data="tableData" border size="mini" style="width: 100%" cell-class-name="table-cell-no-padding" row-class-name="table-row-no-padding"
      header-cell-class-name="table-header-cell">
      <el-table-column type="index" label="序号" align="center">
      </el-table-column>
      <el-table-column label="商品">
        <template v-slot="img">
          <el-image style="width: 40px;" :src="img.row.imageUrl" fit="cover">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="servingStatus" label="有效">
      </el-table-column>
      <el-table-column prop="sellerSKU" label="SKU">
      </el-table-column>
      <el-table-column prop="impressions" label="曝光量" :formatter="dataFormAtter" sortable align="right">
      </el-table-column>
      <el-table-column prop="clicks" label="点击数" :formatter="dataFormAtter" sortable align="right">
      </el-table-column>
      <el-table-column prop="clickRate" label="点击率" :formatter="percentageFormatter" sortable :sort-method="sortClickRate" align="right">
      </el-table-column>
      <el-table-column label="SKU状态">
        <template v-slot="scope">
          <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="2" @change="((val) => {switchChange(val, scope)})">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="averageSpend" sortable label="平均点击单价" :sort-method="sortAverageSpend" align="right">
      </el-table-column>
      <el-table-column prop="spend" sortable label="花费" :sort-method="sortSpend" align="right" >
      </el-table-column>
      <el-table-column prop="orders" sortable label="订单数" align="right">
      </el-table-column>
      <el-table-column prop="sales" sortable label="销售额" :sort-method="sortSales" align="right">
      </el-table-column>
      <el-table-column prop="acos" sortable label="ROAS" :sort-method="sortROAS" align="right">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    adsModules
  } from '@r'
  export default {
    data() {
      return {
        resultTable: [],
        groupId: null,
        date: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              id: 'yesterday',
              text: '前一天',
              onClick: (picker) => {
                console.log(this);
                const end = this.date[0] || '';
                const start = this.date[1] || '';
                const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
                const newStart =  new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
                picker.$emit('pick', [newStart, newEnd]);
              }
            },
            {
              text: '最近一周',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近一个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近三个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },
    created() {

    },
    activated() {
      this.groupId = this.$route.query.groupId - 0;
      const {beginDate, endDate} = this.$route.query;
      (beginDate || endDate) && (this.date = [beginDate, endDate]);
      this.queryAdsList();
    },
    methods: {
      onQueryBtnClick() {
        this.queryAdsList();
      },
      queryAdsList() {
        adsModules.getSkuList({
          // 请求参数
          params: {
            groupId: this.groupId,
            beginDate: this.date[0],
            endDate: this.date[1],
            dsTimeZone: 1
          }
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取列表失败'
            });
            return
          }
          this.resultTable = res.ldata;
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'error',
            message: err.message ? err.message : '列表数据获取失败'
          });
        })
      },
      switchChange(val, scope) {
        adsModules.updateSkuStatus({
          adId: scope.row.id,
          status: val
        }).then((res) => {
          if (res.result !== 1) {
            this.resetSwitch(val, scope);
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
          // this.queryAdsList();
        }).catch((err) => {
          // this.resetSwitch(val, scope);
          this.$message({
            type: 'error',
            message: err.message ? err.message : '编辑出错'
          });
        });
      },
      resetSwitch(newVal, scope) {
        newVal === 1 ? scope.row.status = 0 : scope.row.status = 1
      },
      sortClickRate(rowA, rowB){
        return parseFloat(rowA.clickRate)-parseFloat(rowB.clickRate);
      },
      sortSpend(rowA, rowB){
        return parseFloat(rowA.spend)-parseFloat(rowB.spend);
      },
      sortSales(rowA, rowB){
        return parseFloat(rowA.sales)-parseFloat(rowB.sales);
      },
      sortAverageSpend(rowA, rowB){
        return parseFloat(rowA.averageSpend)-parseFloat(rowB.averageSpend);
      },
      sortROAS(rowA, rowB) {
        let subNumber = isNaN(parseFloat(rowA.acos)) ? 0 : parseFloat(rowA.acos);
        let nextNumber = isNaN(parseFloat(rowB.acos)) ? 0 : parseFloat(rowB.acos);
        return subNumber - nextNumber;
      },
      dataFormAtter(row, column, cellValue, index){
        if([null, undefined, ''].includes(cellValue)){
          return '--';
        }
        return cellValue
      },
      percentageFormatter(row, column, cellValue, index){
        if([null, undefined, ''].includes(cellValue)){
          return '--';
        }
        if(isNaN(+cellValue)){
          return cellValue;
        }
        console.log('skuMgmt');
        return this.$utils.floatRide(cellValue, 100).toFixed(2) + '%';
      }
    },
    computed: {
      tableData: function() {
        this.resultTable.forEach((item, index) => {
          for (var prop in item) {
            if (item[prop] === '' || item[prop] === undefined || item[prop] === null) {
              item[prop] = '--';
            }
          }
          return item;
        });
        return this.resultTable;
      }
    }
  }
</script>

<style lang="scss">
</style>
